import _asyncToGenerator from "D:/hjj/bio_link_pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  class: "message-video"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = ["src", "poster"];
var _hoisted_4 = ["src", "poster"];
var _hoisted_5 = {
  key: 0,
  class: "dialog-video"
};
var _hoisted_6 = ["src"];
import { ref, watch, computed, nextTick, watchEffect } from '../../../../adapter-vue';
import { handleSkeletonSize } from '../../utils/utils';
import Icon from '../../../common/Icon.vue';
import closeSVG from '../../../../assets/icon/icon-close.svg';
import { isPC } from '../../../../utils/env';
var transparentPosterUrl = 'https://web.sdk.qcloud.com/im/assets/images/transparent.png';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-video',
  props: {
    content: {
      default: () => ({})
    },
    messageItem: {
      default: () => ({})
    }
  },
  emits: ['uploading'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emits = __emit;
    var isShow = ref(false);
    var poster = ref('');
    var posterWidth = ref(0);
    var posterHeight = ref(0);
    var skeleton = ref();
    var videoRef = ref();
    watchEffect(/*#__PURE__*/_asyncToGenerator(function* () {
      if (!props.content) return;
      poster.value = yield handlePosterUrl(props.content, props.messageItem);
      nextTick(/*#__PURE__*/_asyncToGenerator(function* () {
        var _document$getElementB;
        var containerWidth = ((_document$getElementB = document.getElementById('messageScrollList')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.clientWidth) || 0;
        var max = !isPC ? Math.min(containerWidth - 172, 300) : 300;
        var size;
        if (props.messageItem.status === 'success') {
          var _skeleton$value, _skeleton$value2;
          var {
            snapshotWidth = 0,
            snapshotHeight = 0
          } = props.content;
          var {
            snapshotUrl
          } = props.content;
          if (snapshotWidth === 0 || snapshotHeight === 0) return;
          if (snapshotUrl === transparentPosterUrl) {
            snapshotWidth = posterWidth.value;
            snapshotHeight = posterHeight.value;
          }
          size = handleSkeletonSize(snapshotWidth, snapshotHeight, max, max);
          (skeleton === null || skeleton === void 0 || (_skeleton$value = skeleton.value) === null || _skeleton$value === void 0 ? void 0 : _skeleton$value.style) && (skeleton.value.style.width = "".concat(size.width, "px"));
          (skeleton === null || skeleton === void 0 || (_skeleton$value2 = skeleton.value) === null || _skeleton$value2 === void 0 ? void 0 : _skeleton$value2.style) && (skeleton.value.style.height = "".concat(size.height, "px"));
          if (isPC) {
            var _videoRef$value, _videoRef$value2;
            (videoRef === null || videoRef === void 0 || (_videoRef$value = videoRef.value) === null || _videoRef$value === void 0 ? void 0 : _videoRef$value.style) && (videoRef.value.style.width = "".concat(size.width, "px"));
            (videoRef === null || videoRef === void 0 || (_videoRef$value2 = videoRef.value) === null || _videoRef$value2 === void 0 ? void 0 : _videoRef$value2.style) && (videoRef.value.style.height = "".concat(size.height, "px"));
          }
        } else {
          emits('uploading');
        }
      }));
    }));
    var isWidth = computed(() => {
      var {
        snapshotWidth = 0,
        snapshotHeight = 0
      } = props.messageItem.payload;
      return snapshotWidth >= snapshotHeight;
    });
    watch(() => props.messageItem.status, (newVal, oldVal) => {
      if (newVal === 'success' && oldVal !== 'success') {
        emits('uploading');
      }
    });
    function toggleVideoPreviewer() {
      // 视频上传过程中不支持全屏播放
      if (props.messageItem.progress > 0 && props.messageItem.progress < 1) {
        return;
      }
      isShow.value = !isShow.value;
    }
    // h5 部分浏览器（safari / wx）video标签 封面为空 在视频未上传完成前的封面展示需要单独进行处理截取
    function getVideoBase64(url) {
      return new Promise(resolve => {
        var dataURL = '';
        var video = document.createElement('video');
        video.setAttribute('crossOrigin', 'anonymous'); // 处理跨域
        video.setAttribute('src', url);
        video.setAttribute('preload', 'auto');
        video.addEventListener('loadeddata', function () {
          var canvas = document.createElement('canvas');
          var width = video.videoWidth; // canvas的尺寸和图片一样
          var height = video.videoHeight;
          canvas.width = width;
          canvas.height = height;
          canvas.getContext('2d').drawImage(video, 0, 0, width, height); // 绘制canvas
          dataURL = canvas.toDataURL('image/jpeg'); // 转换为base64
          posterWidth.value = width;
          posterHeight.value = height;
          resolve(dataURL);
        }, {
          once: true
        });
      });
    }
    function handlePosterUrl(_x, _x2) {
      return _handlePosterUrl.apply(this, arguments);
    }
    function _handlePosterUrl() {
      _handlePosterUrl = _asyncToGenerator(function* (messgeContent, messageItem) {
        if (!messageItem) return '';
        if (messageItem.status !== 'success') {
          return yield getVideoBase64(messgeContent.url);
        } else {
          var _messageItem$payload, _messageItem$payload2, _messageItem$payload3, _messageItem$payload4;
          return messgeContent.snapshotUrl !== transparentPosterUrl && messgeContent.snapshotUrl || (messageItem === null || messageItem === void 0 || (_messageItem$payload = messageItem.payload) === null || _messageItem$payload === void 0 ? void 0 : _messageItem$payload.snapshotUrl) !== transparentPosterUrl && (messageItem === null || messageItem === void 0 || (_messageItem$payload2 = messageItem.payload) === null || _messageItem$payload2 === void 0 ? void 0 : _messageItem$payload2.snapshotUrl) || ((_messageItem$payload3 = messageItem.payload) === null || _messageItem$payload3 === void 0 ? void 0 : _messageItem$payload3.thumbUrl) !== transparentPosterUrl && (messageItem === null || messageItem === void 0 || (_messageItem$payload4 = messageItem.payload) === null || _messageItem$payload4 === void 0 ? void 0 : _messageItem$payload4.thumbUrl) || (yield getVideoBase64(messgeContent.url));
        }
      });
      return _handlePosterUrl.apply(this, arguments);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        ref_key: "skeleton",
        ref: skeleton,
        class: _normalizeClass(["message-video-box", [(!props.messageItem.progress || props.messageItem.progress === 1) && !_unref(isPC) && 'message-video-cover']]),
        onClick: toggleVideoPreviewer
      }, [props.messageItem.progress > 0 && props.messageItem.progress < 1 && _unref(poster) || !_unref(isPC) && _unref(poster) ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: _normalizeClass(["message-img", [_unref(isWidth) ? 'is-width' : 'is-height']]),
        src: _unref(poster)
      }, null, 10, _hoisted_2)) : !_unref(isPC) ? (_openBlock(), _createElementBlock("video", {
        key: 1,
        ref_key: "videoRef",
        ref: videoRef,
        class: "message-img video-h5-uploading",
        src: props.content.url + '#t=0.1',
        poster: props.content.url,
        preload: "auto",
        muted: ""
      }, null, 8, _hoisted_3)) : (_openBlock(), _createElementBlock("video", {
        key: 2,
        ref_key: "videoRef",
        ref: videoRef,
        class: "message-img video-web",
        src: props.content.url,
        controls: "",
        preload: "metadata",
        poster: _unref(poster)
      }, null, 8, _hoisted_4))], 2), _unref(isShow) && !_unref(isPC) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", {
        class: "dialog-video-close",
        onClick: _withModifiers(toggleVideoPreviewer, ["stop"])
      }, [_createVNode(Icon, {
        file: _unref(closeSVG)
      }, null, 8, ["file"])]), _createElementVNode("div", {
        class: _normalizeClass(["dialog-video-box", [!_unref(isPC) ? 'dialog-video-h5' : '']]),
        onClick: _withModifiers(toggleVideoPreviewer, ["self"])
      }, [_createElementVNode("video", {
        class: _normalizeClass([_unref(isWidth) ? 'is-width' : 'is-height']),
        src: props.content.url,
        controls: "",
        autoplay: ""
      }, null, 10, _hoisted_6)], 2)])) : _createCommentVNode("", true)]);
    };
  }
});